var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7590_7342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.09099 7.72732V8.63642H8.18188V10.0001H9.09099V14.091H10.9092V10.0001H12.1183L12.2728 8.63642H10.9092V7.84095C10.9092 7.47279 10.9455 7.27732 11.5137 7.27732H12.2728V5.90912H11.0546C9.60009 5.90916 9.09099 6.59095 9.09099 7.72732Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6.10352e-05C4.47715 6.10352e-05 0 4.47721 0 10.0001C0 15.5229 4.47715 20.0001 10 20.0001C15.5229 20.0001 20 15.5229 20 10.0001C20 4.47721 15.5229 6.10352e-05 10 6.10352e-05ZM10 19.091C4.97922 19.091 0.909102 15.0208 0.909102 10.0001C0.909102 4.97928 4.97922 0.909163 10 0.909163C15.0208 0.909163 19.0909 4.97928 19.0909 10.0001C19.0909 15.0208 15.0208 19.091 10 19.091Z",
    fill: "#888888"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7590_7342"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/icon-facebook.135f2446cf509da4bb1f8ca604ae0dc5.svg";
export { ForwardRef as ReactComponent };